<template>
  <v-card
    flat
    height="100%"
    width="100%"
    v-resize="onResize"
    ref="navContentContainer"
    class="activity-bottom-nav-view"
  >
    <l-map-view
      v-if="bottomNav === 'map'"
      ref="map"
      :style="contentStyle"
      :polyline="polyline"
      :bounds="bounds"
      :show-attribution="false"
    />
    <elevation-profile v-if="bottomNav === 'profile'" :points="points" :height="contentHeight" />
    <activity-stats v-if="bottomNav === 'stats'" :activity="activity" />
    <segment-effort-list
      v-if="bottomNav === 'segments'"
      :style="contentStyle"
      :segment-efforts="activity && activity.segment_efforts ? activity.segment_efforts : []"
      @segmment-clicked="onSegementClicked"
    />
    <!-- <activity-segments
      v-if="bottomNav === 'segments'"
      class="segment-full-screen"
      :style="contentStyle"
      :segments="activity && activity.segment_efforts ? activity.segment_efforts : []"
      @item-hover="(a) => hoveredSegment = a"
    />-->
    <v-bottom-nav
      :active.sync="bottomNav"
      :value="true"
      :style="navBarStyle"
      color="transparent"
      ref="navBar"
    >
      <v-btn color="primary" flat value="map">
        <span>Map</span>
        <v-icon>map</v-icon>
      </v-btn>
      <v-btn color="primary" flat value="profile">
        <span>Profile</span>
        <v-icon>landscape</v-icon>
      </v-btn>
      <v-btn color="primary" flat value="segments">
        <span>Segments</span>
        <v-icon>timeline</v-icon>
      </v-btn>
      <v-btn color="primary" flat value="stats">
        <span>Stats</span>
        <v-icon>equalizer</v-icon>
      </v-btn>
      <v-btn color="primary" flat value="images">
        <span>Images</span>
        <v-icon>photo_camera</v-icon>
      </v-btn>
      <portal to="context-portal">
        <activity-header-2 :activity="activity" />
      </portal>
    </v-bottom-nav>
  </v-card>
</template>

<script>
import dataAccessor from '@/data-access/dataAccessor';
import MapView from '@/ux/generic-components/MapView.vue';
import LMapView from '@/ux/generic-components/LMapView.vue';
import ActivitySegments from '@/ux/components/activities/ActivitySegments.vue';
import ActivityStats from '@/ux/components/activities/ActivityStats.vue';
import SegmentEffortList from '@/ux/components/segments/SegmentEffortList.vue';
import ActivityHeader2 from '@/ux/components/headers/ActivityHeader2.vue';
import ActivityHeader from '@/ux/components/headers/ActivityHeader.vue';
import ElevationProfile from '@/ux/generic-components/ElevationProfile.vue';
import loadingMixin from '@/mixins/loadingMixin';
import sizeAwareMixin from '@/mixins/sizeAwareMixin';
import PolylineDecoder from '@/library/PolylineDecoder';
import geometry from '@/library/Geometry';
import activity from '@/routes/activity';
import logger from '@/domain/ClientLogger';
import eventBus from '@/events/eventBus';

export default {
  name: 'activity-botton-nav-view',
  components: { LMapView, MapView, ActivitySegments, ActivityHeader, ElevationProfile, ActivityHeader2, ActivityStats, SegmentEffortList },
  props: {
    id: {
      type: [Number, String],
      required: true,
      default: null,
    },
  },
  mixins: [loadingMixin, sizeAwareMixin],
  data: () => ({
    activity: {},
    polyline: null,
    hoveredSegment: null,
    mapOnly: false,
    points: [],
    bottomNav: 'stats',
    contentHeight: '',
    footerTop: 600,
    navBarTop: 600,
  }),
  computed: {
    bounds() {
      let bnds = null;
      if (this.hoveredSegment) {
        bnds = geometry.bounds([geometry.toLatLng(this.hoveredSegment.segment.start_latlng),
        geometry.toLatLng(this.hoveredSegment.segment.end_latlng)]);
      }
      return bnds;
    },
    contentStyle() {
      return `height: ${this.contentHeight};`;
    },
    navBarStyle() {
      const h = this.$refs.navBar ? this.$refs.navBar.$el.clientHeight : 56;
      this.navBarTop = this.footerTop - h;
      return `position: fixed;top: ${this.navBarTop}px;`;
    },
  },
  mounted() {
    eventBus.on('viewport-changed', this.setViewport);
    this.setViewport();
    this.load();
  },
  beforeDestroy() {
    eventBus.off('viewport-changed', this.setViewport);
  },
  methods: {
    onSegementClicked(effort) {
      this.$router.push({ name: 'segmentView', params: { id: effort.segment.id, segment: effort.segment } });
    },
    setViewport() {
      this.footerTop = this.$store.getters.viewport.bottom;
      this.$nextTick(() => {
        this.contentHeight = this.calcContentHeight();
      });
    },
    async onResize(args) {
      this.contentHeight = this.calcContentHeight();
    },
    async load() {
      this.loadingStart(`Loading activity`);
      const d = new PolylineDecoder();
      this.activity = await dataAccessor.getActivity(this.id);
      this.points = await dataAccessor.getActivityStreams(this.id);
      this.centre = { lat: this.activity.start_latlng[0], lng: this.activity.start_latlng[1] };
      this.polyline = this.activity && this.activity.map ? this.activity.map.polyline : [];
      this.loadingEnd();
    },
    calcContentHeight() {
      if (this.$refs.navContentContainer && this.$refs.navBar) {
        const r1 = this.$refs.navContentContainer.$el.getBoundingClientRect();
        const hm = `${this.navBarTop - r1.top}px`;
        return hm;
      }
    },
  },
};
</script>


<style lang="scss">
.activity-bottom-nav-view {
  .segment-full-screen {
    overflow-y: auto;
    // height: 100%;
  }
  // .v-tab__item {
  //   padding: 0px;
  // }

  // .v-window {
  //   height: 100%;
  //   .v-window__container {
  //     height: 100%;
  //   }
  //   .v-window-item {
  //     height: 100%;
  //   }
  // }
}
</style>